(function ($) {
  $(document).ready(function () {

    var AdaptTable = function($table) {
      var self = this;
      this.table = $table;
      this.container = $table.closest('.js-container');
      this.tableInitWidth = this.table.width();
      this.containerInitWidth = this.container.width();
      this.adapt = function (tableWidth,containerWidth) {
        if(tableWidth > containerWidth) {
          // add adaptive class
          if(!this.table.hasClass('adapt-to-container')) {
            this.table.addClass('adapt-to-container');
          }
        }

        if ((tableWidth <= containerWidth && !(tableWidth < this.tableInitWidth)) || containerWidth > this.tableInitWidth) {
          // remove adaptive class
          if(this.table.hasClass('adapt-to-container')) {
            this.table.removeClass('adapt-to-container');
          }
        }
      };
      this.init = function () {
        this.adapt(this.tableInitWidth,this.containerInitWidth);
        $(window).resize(function() {
          self.tableWidth = self.table.width();
          self.containerWidth = self.container.width();
          self.adapt(self.tableWidth,self.containerWidth);
        })
      };
      this.init();
    };

    $($('.js-adapt-tables').find('table')).each(function(key,value) {
      new AdaptTable($(value))
    });

  });
})(jQuery);
